import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'jsl_cookie_consent';

type Consent = 'accepted' | 'rejected' | null;

export function useCookieConsent() {
  const [consent, setConsent] = useState<Consent>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'accepted' || stored === 'rejected') {
      setConsent(stored);
    }
    setReady(true);
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setConsent('accepted');
  }, []);

  const reject = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setConsent('rejected');
  }, []);

  return { consent, accept, reject, ready };
}
